import { OTP_BANK_ACCOUNT_NUMBER_PREFIX } from 'common/js/constants/constants';
const ACCOUNT_NUMBER_SEGMENT_REGEX = /^\d{8}$/;
const ACCOUNT_NUMBER_NO_OTP_PREFIX_REGEX_SHORT = /^\d{5}-\d{8}$/;
const ACCOUNT_NUMBER_NO_OTP_PREFIX_REGEX_LONG = /^\d{5}-\d{8}-\d{8}$/;
const BANK_ACCOUNT_NUMBER_SEPARATOR = '-';
const SEGMENTS_NUMBER_LONG = 3;
const SEGMENTS_NUMBER_SHORT = 2;
const FIRST_INDEX = 0;
const CDV_MULTIPLIERS = [9, 7, 3, 1];

function segmentIsValid(segment) {
	let numbers = segment.split('');
	let sum = 0;
	for (let i = 0; i < numbers.length; i++) {
		sum += numbers[i] * CDV_MULTIPLIERS[i % CDV_MULTIPLIERS.length];
	}
	return sum % 10 == 0;
}

function getRestOfCollection(coll) {
	let result = '';
	for (let i = FIRST_INDEX; i < coll.length; i++) {
		if (i > FIRST_INDEX) {
			result += coll[i];
		}
	}
	return result;
}

function validateSegments(accountNumberSegments) {
	let resultArray = accountNumberSegments.filter(segmentIsValid);
	return resultArray.length == accountNumberSegments.length;
}

function validateBySegmentsNumber(accountNumberSegments) {
	switch (accountNumberSegments.length) {
		case SEGMENTS_NUMBER_LONG:
		case SEGMENTS_NUMBER_SHORT:
			return validateSegments([accountNumberSegments[FIRST_INDEX], getRestOfCollection(accountNumberSegments)]);
		default:
			return false;
	}
}

function cdvIsValidForSegments(accountNumberSegments) {
	let allMatchesRegexp = true;
	for (let i = 0; i < accountNumberSegments.length && allMatchesRegexp; ++i) {
		allMatchesRegexp = ACCOUNT_NUMBER_SEGMENT_REGEX.test(accountNumberSegments[i]);
	}
	if (allMatchesRegexp) {
		return validateBySegmentsNumber(accountNumberSegments);
	}
	return false;
}

function cdvIsValidForExistingAccountNumber(accountNumber) {
	let accountNumberSegments = accountNumber.split(BANK_ACCOUNT_NUMBER_SEPARATOR, SEGMENTS_NUMBER_LONG).filter((item) => !!item);
	return cdvIsValidForSegments(accountNumberSegments);
}

export default (value) => {
	if (!value) {
		return true;
	}
	if (value.replace(/-/g, '').length == 13 && value.endsWith('-')) {
		value = value.substring(0, value.length - 1);
	}
	// vannak olyan inputmezők, ahol a 117 prefix nem része az inputnak
	if (ACCOUNT_NUMBER_NO_OTP_PREFIX_REGEX_SHORT.test(value) || ACCOUNT_NUMBER_NO_OTP_PREFIX_REGEX_LONG.test(value)) {
		value = OTP_BANK_ACCOUNT_NUMBER_PREFIX + value;
	}
	return cdvIsValidForExistingAccountNumber(value);
};
